import api from "../core/http";

/**
 * Get reading orders requests
 * @returns
 */
export const getRequests = () => {
  return api
    .get("/v1/requests")
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Search comics by title
 * @param {*} searchTerm
 * @returns
 */
export const storeRequest = (description) => {
  return api
    .post("/v1/requests", { description })
    .then((res) => res.data)
    .catch((err) => err);
};
